const STORAGE_REGEX = /^\d{10}$/;

const onlyDigits = (value) => (value ?? '').replace(/\D/g, '');

export const normalizeTelefonoForStorage = (value = '') => {
    let digits = onlyDigits(value);
    if (digits.startsWith('549') && digits.length >= 13) digits = digits.slice(3);
    else if (digits.startsWith('54') && digits.length >= 12) digits = digits.slice(2);
    else if (digits.startsWith('0') && digits.length >= 11) digits = digits.slice(1);
    digits = digits.slice(0, 10);
    return STORAGE_REGEX.test(digits) ? digits : '';
};

export const isTelefonoCordobaValido = (value = '') => STORAGE_REGEX.test(value || '');
